import type { AuthUser } from '../../types/user';

/** Админ или суперадмин — им доступны разделы под /access. */
export const isAdmin = (user?: AuthUser | null): boolean =>
    user?.role === 'admin' || user?.role === 'super_admin';